import { dictumsType } from "./dictum";

// 剑来语录数据
export const jianlaiDictums: dictumsType = [
  '遇事不决，可问春风。',
  '君子慎独，克己复礼。',
  '行走江湖，我有一剑！',
  '命里八分，莫求一丈。',
  '本事不够，喝酒来凑。',
  '人心经不起推敲试探！',
  '身前无人，双拳而已。',
  '呼啸成风，势大力沉。',
  '心定且赤诚，何其难也。',
  '愿先生心境，四季如春。',
  '入秋时节，却如沐春风。',
  '“言念君子，温其如玉。”',
  '“命里八分，莫求一丈。”',
  '“遇事不绝，可问春风。”',
  '酒能红双颊，愁能雪白头。',
  '人情送头牛，买卖不饶针。',
  '有些人心如花木，皆向阳而生',
  '我登楼观百川，入海即入我怀',
  '“少年思无邪，最最动人心”',
  '有些人心怀花木，皆向阳而生',
  '纯粹的自由，需要献祭人性。',
  '陇上花又开，先生缓缓归矣。',
  '江湖没什么好的，也就酒还行。',
  '秉烛夜游之人，自身在光明中。',
  '有些人心如花木，皆向阳而生。',
  '我辈大道修行，切忌担夫争道。',
  '人心有反复，好在山水有相逢。',
  '好个风月无边，碎圆又有相逢。',
  '胸中一点浩然气，天地千里快哉风',
  '春王正月，大雨霖以震，书始也。',
  '江湖也没什么好的，也就酒还好。',
  '背后不说人是非，公道自在人心。',
  '“君子坐而论道，少年起而行之。”',
  '但愿世间人无病，宁可架上药成灰！',
  '人生有聚终有散，所幸有散又有聚。',
  '既然拿得起，就没有放得下的道理。',
  '此去归路心茫然，无数青山水拍天。',
  '年少如何久年少，少年如何长少年。',
  '礼数在简在醇正，不在繁多不在表。',
  '运到盛时须儆省，境至逆处要从容。',
  '吾心安处即吾乡。吾乡何处不可眠。',
  '为善而不知是善，为恶而自知是恶。',
  '送人之时唯豪气，事后想起心肝疼。',
  '真正的强者，愿意以弱者的自由为边界',
  '人生何处不相逢，总有再见面的一天。',
  '月色入高楼，烦，它也来，恋，它也去。',
  '傻一点，总比精明得半点不聪明，要好。',
  '既然做不得更多，你往好处多想就是了。',
  '人生天地间，大丈夫泪目，必是心碎时。',
  '这一年，这座天下，春去极晚，夏来极迟。',
  '每个伤透心的故事 都有一个暖人心的开头',
  '自童年起，我就独自一人，照看历代星辰。',
  '故乡垄头，陌上花开，先生可以缓缓归矣。',
  '“碎碎平，碎碎安，碎碎平安，岁岁平安。”',
  '对天地怀有敬畏之心，将自己视为生死大敌。',
  '遇事不决，可问春风，春风不语，既随本心。',
  '知而不行，谓之不诚。 行而不成，谓之不能。',
  '许多今日之心心念念，无非是来年之付诸一笑。',
  '该是你的，就拿好别丢。不该是你的，想都别想。',
  '像是一场离愁的秋雨，不大也不小，可就是伤心。',
  '魏檗摇头道：既然拿得起，就没有放得下的道理。',
  '总有些人，一眼看到便会心生好感，道理都讲不通。',
  '何谓心仪，大概是人海熙攘，惊鸿一瞥，再难忘记。',
  '今人见过昔年月，今月曾经照故人，都曾见过她啊。',
  '当我们对这个世界很挂念，便会把日子过的很辛苦。',
  '情到深处，知悔不愿悔。 爱至浓时，情殇不算伤 。',
  '天底下只要是真正好看的女子，说不说话，都是风景。',
  '我先跟自己比，自己觉得问心无愧了，再跟其他人比！',
  '我希望有一天，当我陈平安站在某处，道理就在某处。',
  '不得拳真意，百年门外汉。一悟拳真意，十年打鬼神。',
  '百事忙千事忧，到头来万事休，天凉好个秋呀好个秋！',
  '修心，亦是修行之一。顺境修力，逆境修心，缺一不可。',
  '有些事情，死了也要做。但有些事情，是死也不能做的。',
  '何谓遗憾，不可再得之物， 不可再遇之人，就是遗憾。',
  '他的人生总是这样，真正在意的人，好像如何也挽留不住。',
  '世事无奈人无奈，能说之时不想说，想说之时已是不能说。',
  '人生不如意之事七八九，能与人言一二三都无，才算坎坷。',
  '喝了酒，就敢想不敢想的，敢说不敢说的，敢做不敢做的。',
  '世间万般讲理与不讲理，终归会落在一处，我心安处即吾乡。',
  '世间事，皆有脉络可供观看，世上人，所思所想皆有迹可循。',
  '世间人，纵有不舍，终有别离，世间事，纵有遗憾，且放心间',
  '我喜欢的姑娘她眉如远山，眼似明镜，在我的心尖儿上晃呀晃',
  '有些事情做了，是因为必须要做，不代表我就一点不害怕啊。',
  '真正的强者，都应该以弱者的自由为边界，当出剑向更强处。',
  '没有修复和重建能力的破坏，都是自取灭亡，不是长久之道。',
  '世间成事者，超世之才不过其次，坚韧不拔之志，方为首要。',
  '少年一笑出门去，千里落花风。如今青衫仗剑回，山河满春风。',
  '年少时，大抵如此，总觉得不守规矩，才是一件有本事的事情。',
  '少年飞跃溪水的时候，就像一头经常盘旋在小镇天空的捕蛇鹰。',
  '桃花开时，若是花上还有黄鹂，尤为动人，眼不敢动，心魄动也。',
  '有些人之间，注定只要相逢就是对的，若是还能相逢，就是最好的',
  '有些委屈，无论大小，只有受过同样委屈的人，才可以真正体会。',
  '陈平安，记住，以后不管遇到什么，都不要对这个世界失去希望。',
  '不是“我觉得”三个字，可以弥补所有因为好心办坏事带来的后果。',
  '喜欢谁，我自己又管不住自己的，你觉得轻浮就你觉得，我也不管你。',
  '有些人之间，注定只要相逢，就是对的。如果还能重逢，就是最好的。',
  '但这不妨碍那些还能再见的相逢，让人欢喜，让人饮酒，让人开心颜。',
  '认定一件事，即使拿十分力气都无法完成，也要拿出十二分力气去努力。',
  '常年不言不语之人，要么性情憨厚不善言辞，要么就是心计多如牛毛了。',
  '江湖没什么好的，也就酒还行，酒呢，来来来！谁来与我共饮这江湖酒？',
  '山外风雨三尺剑，有事提剑下山去；云中花鸟一屋书，无忧翻书圣贤来。',
  '混吃等死，小富即安，飞黄腾达，是因为各有各的缘法，未必有高下之分。',
  '石头清白如水，桃花漂浮其中。 就像桃叶巷那边的雨后桃花，霁色茏葱。',
  '初衷是好的，你所希冀的结果也是好的，但这是你不择手段行事的理由吗？',
  '某些人和事，哪怕是路边的风景，可是只要看一眼，依然会让人觉得很美好。',
  '一个肆意摔罐子砸瓶子的人，永远要比护住每一只瓶瓶罐罐的人要轻松几分。',
  '该省之省，一文铜钱，即是家族根本。该花则花，一掷千金，根本无需眨眼。',
  '溪水渐浅，井水渐冷，老槐更老，铁锁生锈，大云低垂。 今年桃叶见不到桃花。',
  '人间一半剑仙是我友，天下哪个娘子不娇羞，我以醇酒洗我剑，谁人不说我风流！',
  '看春风不喜，看夏蝉不烦，看秋风不悲，看冬雪不叹。脚步再匆匆，人生需从容。',
  '道理，不是弱者只能拿来诉苦喊冤的东西，不是必须要跪下磕头才能开口的言语。',
  '喝酒真的那么有意思吗？光喝酒当然没啥意思，是喝酒桌上的人，是喝酒桌外的事。',
  '所有难熬又熬过去的苦难，就是在心头砸下一个坑，坑越大，以后就可以容纳更多。',
  '整个浩然天下都是你儒家的门户，贫道就偏偏要在你家里，独立开辟出一座小花园。',
  '又要多知道些别人与自己的不同之处，才会知道别人到底是为何活得好，活得不好。',
  '每一位修道之人，其实就是每一座自身小天地的老天爷，凭自家功夫，做自家圣人。',
  '一个姑娘，如果有被人喜欢，而且那个人喜欢得干干净净，怎么都是一件美好的事情。',
  '簪子上有八个字，便是仅算粗通文墨的少女，也觉得极为动人。言念君子，温其如玉。',
  '仙，迁也，迁入山也。红尘多烦忧，藕断又丝连。故而宜入名山，身也清净心也清静。',
  '簪子上有八个字，便是仅算粗通文墨的少女，也觉得极为动人。 言念君子，温其如玉。',
  '天底下好看的女子多了去，好看就多看一两眼，悦目养眼嘛，人之常情，可为啥要心动。',
  '情爱一物，是烧菜的佐料，有了是最好，可没有，不打紧，总有从别处找补回来的事物。',
  '愿那人间有情人，成双成对，终成眷属，愿白首不负心的已逝之人，生生死死皆在一起。',
  '有心为善虽善不赏，无心为恶虽恶不罚。人力有穷尽之时，尽力又尽心了，就不用太愧疚。',
  '我喜欢的姑娘啊，她眉如远山，浩然天下所有好看的山，好看的水加起来，都不如她好看。',
  '如何变坏为好，是本事，好上加好，更是能耐。真正看着世间万物的，不是双眼，是人心。',
  '天道崩塌，我陈平安唯有一剑，可搬山，断江，倒海，降妖，镇魔，敕神，摘星，摧城，开天',
  '看似给他很多选择，其实就是没得选择。人生路上，不都如此？不单是陈平安身陷如此困局。',
  '会真正折损自身利益的时候，还能分出是非，明辨取舍，不以得失乱心境，才是真正的道理。',
  '孩子低着头，双手使劲攥紧系挂箩筐的绳子，摇摇晃晃，离开了宅子和巷子，再也没有回家。',
  '世间一个个文字，是有力量的。字眼组合成词，词汇串联成句，语句契合成文章。大道就在其中。',
  '人生不是书上的故事，喜怒哀乐，悲欢离合，都在书页间，可书页翻篇何其易，人心修补何其难。',
  '是你的就好好抓住，不是你的就不要多想。天底下没谁是欠你的，但是你欠了别人，就别不当回事。',
  '人生路上，总会有那么几场疾风骤雨，就像是老天爷在提醒世人，你们是在寄人篱下，要乖乖低头。',
  '以后行走四方，如果真有女子喜欢我，我未必拦得住，可我这辈子能不能只喜欢一个人，是做得到的。',
  '不是有件事你做对了，别人没做，他们就是不对的。不是有件事你做错了，别人做了，他们就也是错的。',
  '只是两个人相处，那么喜欢一个人，可能会觉得她所有都好，但是以后在一起了，就要学会喜欢她的不好。',
  '是那“君子不妄动，动必有道。君子不徒语，语必有理。君子不苟求，求必有义。君子不虚行，行必有正！',
  '至于你们啊，太不讲理了。读书人不该如此霸道的。应该以圣贤道理教化苍生，应当春风化雨，润物无声。',
  '如果你的朋友过得比你好，好很多，好到让你望尘莫及，一辈子追不上，那么你心里头会不会一点点别扭？',
  '前贤以言语铺路，你大步走去即可，临水而观，低头见那水中月碎又圆，抬头再见本相月，本就更显光明。',
  '观海者难为水，痴心者难为情呐 男女情爱之苦乐，不过是意中人变成了忆中人，或是心上人变成了枕边人。',
  '一次机缘之下，左右得到了那把佩剑后，小齐曾笑言，偶得三尺剑，跨海斩长鲸，收鞘挂壁上，犹有铮铮鸣。',
  '剑客酩酊睨醉乡，道心大天地小，乾坤窄酒杯宽，古今短意气长。唯我一笑抚青萍，手中三尺剑，不曾负平生。',
  '人都会长大的，长大了之后，就会捡起一些新东西，丢掉一些旧东西，就这么丢丢捡捡，哗啦一下子，就老喽。',
  '一个随便把别人当朋友的人，往往不会有真正的朋友。一个喜欢嘴上称兄道弟的人，心里其实没有真正的兄弟。',
  '请不要把陌生人的些许善意，视为珍稀的瑰宝，却把身边亲近人的全部付出，当做天经地义的事情，对其视而不见',
  '不要把陌生人的些许善意，视为珍稀的瑰宝；却把身边亲近人的全部付出，当做天经地义的事情，对其视而不见。',
  '我是否喜欢谁，与谁喜不喜欢我，半颗铜钱关系都没有。就像山看水，水流山还在，喜欢之人，只管远去，我只管喜欢',
  '什么家国仇恨浩然正气的，都不要急。先挑起清风明月，杨柳依依和草长莺飞。少年郎的肩头，本就应当是美好的事物啊。',
  '别人的大道再好，那也是别人的道路，不妨埋头做事，但问耕耘莫问收获，偶尔抬头，左右看两眼其它路上的人物风光，就够了。',
  '开玩笑没关系，但是切记言多必失。世间一个个文字，是有力量的。字眼组合成词，词汇串联成句，语句契合成文章。大道就在其中。',
  '少年大笑出门去，千里落花风；如今青衫仗剑回，山河满春风；美人赠我金刀错，剑气长城剑气近；人间清都山水郎，少年最为思无邪！',
  '一个人的本性单纯淳朴，完全不等同于憨傻迟钝，要做真正的好人，得知道什么是坏人。一个好人能够好好活着，就是对这个世界最大的善意。',
  '世间道理，其实一直在，有人捡起，奉若圭臬，视为珍宝，有人不屑，甚至还有人会踩上几脚。 这不是道理不对，不好。 而是人心出了问题。',
  '少女蓦然勃然大怒，一拍桌子，质问道：“你是不是喜欢我？！” 陈平安呆若木鸡。 少女咧嘴一笑，朝陈平安伸出大拇指道：“眼光不错！”',
  '“读过多少书，就敢说这个世道‘就是这样的’，见过多少人，就敢说男人女人‘都是这般德行’?你亲眼见过多少太平和苦难，就敢断言他人的善恶?”',
  '少年的肩膀，就该这样才对嘛，什么家国仇恨，浩然正气的，都不要急，先挑起清风明月、杨柳依依和草长莺飞，少年郎的肩头，本就应当满是美好的事物啊。',
  '我们所处的世道，总是这般复杂，走着走着，杂草丛生，荒庙破寺。走着走着，杨柳依依，桃花烂漫。走着走着，穷山恶水，夜幕深沉。走着走着，琼楼玉宇，大放光明。',
  '一夜无话，最后宁姚靠着陈平安的肩头，怡然酣睡到清晨。 陈平安纹丝不动，安静守夜。 他曾经见过一句很动人的诗句。 “自童年起，我便独自一人，照顾着历代星辰。”',
  '有聚终有散，人生就是一场场折柳。 岁月长河里，仿佛存在着一座座杨柳依依的渡口，每一段光阴逆旅当中，会有人离船而去，有人登船作伴，然后在下一座渡口又有新的聚散离别。',
  '所以说啊，做好人是一件很累的事，千万不能因为做了好人却没有得到回报或者得到的是意料之外的东西就觉得自己做错了，更不能觉得自己以后再也不当好人了。这样...是不对的!',
  '天底下哪有死物比活人的性命还重要的?一定要活下去，哪怕不能好好活着，也要活着，天底下没有比这更大的道理了。壮壮烈烈而死，慷慨激昂赴死，风流写意去死，可死了就是死了啊',
  '少年喜欢少女，是饮糯米酒酿，酒味其实不重，可是初次喝酒，也能醉人。长大之后，男子喜欢女子，如饮烧酒，一个不小心就要烧断肝肠。上了岁数，老人思念女子，是大冬天，温了一壶黄酒。',
  '如果换成是以前，李槐看到自己爹这样，会觉得丢脸，但是这一次，李槐没有。 他爹是没本事，但是他爹这辈子，把能给他李槐的，已经都给了。 如今李槐觉得他爹不管做什么，都不会丢人。',
  '崔东山没来由说了一句，“要把自己放得很低，眼光看得很高。” 于禄问道：“不是看得很远？” “人在毫无希望的困境里，是绝对看不长远的。” 崔东山摇摇头，“但是谁都拦不住我们抬头看天。“',
  '是非功过有人心，善恶斤两问阎王。为何有此说？因为每个人的道德修养、成长经历、眼界阅历都会不同，人心起伏不定，有几人敢自称自己的良心，最为中正平和？” 有些违心的事情，一步都不要走出去。',
  '“为人，则秉一口浩然气，顶天立地大丈夫。” “当神，既然争了那一炷香，就要泽被苍生，哪怕神道已崩，我就要证明香火不绝，吾道不孤。” “做鬼，天地不要我生，我偏偏要在罡风春雷之中证长生。',
  '这一日， 倒悬山多了一位外乡的剑仙。 无人知其姓名 山水邸报也未有记载 只知他两把飞剑惊才绝艳 一柄红炉，一柄点血。 那外乡剑仙城头酩酊大醉后独往蛮荒，剑斩王座，潇洒而去 唯有城墙上刻字“来过”。',
  '月辉素洁，青衫儒士在陈平安身侧，一起跟随少年前行出拳，亦是悠然。 陈平安走完一趟拳桩后，轻轻停下脚步，不再练拳。 他没有转头望去，就那么看着远方，陈平安双袖再无春风萦绕。 他知道。 齐先生，真的走了。',
  '被人喜欢，是一件很难得、需要很珍惜的事情，比不被讨厌还要难嘛，所以可不是一件可以拿来炫耀的事情，就应该只是一件偷藏在心里的高兴事啊，然后偶尔心情不好的时候，一开门，就会高兴嘞，一开门就心情好，所以就叫‘开心’嘛。”',
  '天上月似拢起雪，人间雪似碎开月。 孤光冷艳照眼眸，月雪两清绝，惟有人多余。 天上月，人间月，负笈求学肩上月，登高凭栏 眼中月，竹篮打水碎又圆。 山间风，水边风，御剑远游脚下风，圣贤书斋翻书风，风吹浮萍有相逢。 风月无边，碎圆又有相逢。 陆沉',
  '一位姑娘不喜欢你，一定是你还不够好，等到你哪天觉得自己足够好了，姑娘兴许也嫁人了，然后连她的孩子都能出门打酱油了，在路上看见你，喊你叔叔，那会别伤心，是缘分错了，不是你喜欢错了人，记住，那位姑娘嫁人了就别纠缠不清了，把那份喜欢藏好，都放在酒里。',
  '唯有读第一流的书，才有希望当第二流的人。读书一事，不可求全，贪多嚼不烂，以精读为上，细嚼慢咽，真正把一本经典的精妙，全部吃进肚子里，将那些美好的意象、真知灼见的道理、隐匿于句章之间的精气神，一一化为己用，这才叫读书，否则只是翻书，翻过千万卷，撑死也是个两脚书柜。',
  '每个人都有自己的一本书，有些人写了一辈子的书，喜欢翻开书给人看，然后满篇的岸然巍峨、高风明月、不为利动，却唯独无善良二字，但是又有些人，在自家书本上从来不写善良二字，却是满篇的善良，一翻开，就是草长莺飞、向阳花木，哪怕是隆冬酷暑时节，也有那霜雪打柿、柿子红通通的活泼景象。​',
  '那年冬天，女子终究还是没能熬过年关，没能等到儿子贴上春联和门神，死了。她闭眼之前，小镇刚好下起了雪，她让儿子出去看雪。女子听着儿子跑出屋子的脚步，闭上眼睛，虔诚默念道：“碎碎平碎碎安，碎碎平安，我家小平安，岁岁平安，年年岁岁，岁岁年年，平平安安……” 从那一天起，陈平安就成了孤儿',
  '只听少年摇头笑道：“喜欢一个人总得让她开心吧，如果觉得喜欢谁，谁就一定要跟自己在一起，这还是喜欢吗？” 说到这里，少年眼泪便流了下来，“可是我就是嘴上这么说说的，其实我都快伤心死了。我其实恨不得整个倒悬山，整个浩然天下都知道我喜欢那个姑娘。然后我只希望天底下就这么一个姑娘，喜欢我',
  '宁姚翻了个白眼“我有那么不讲理吗？”陈平安愣了一下。然后宁姚斩钉截铁道“对，我就是这么不讲理！” 她蓦然笑了起来，充满了稚气的得意，她一笑起来，便愈发眉眼如画，生动活泼，她双手环胸“谁让有个傻子喜欢我呢” 然后她一把抱住了那个大骊少年喃喃道：“陈平安我喜欢你，不比你喜欢我少一点点',
  '当我行走于天地间，骄阳烈日，明月当空，得问我一句，天地之间足够亮堂否？ 不太够？ 当我行走于江湖上，大江滔滔，河水滚滚，得问我一句，江河之水足够解渴否？ ：“不够！” 当我行走于群山巅，琼楼玉宇，云海仙人，得问我一句，山顶罡风足够凉快否？ 不够不够！远远不够！酒不够，江水山风不够！都不够！',
  '那个老书生说，我们活在一个很复杂的世道里，很多人的言行，哪怕是学问极高的读书人，还是会自相矛盾，我们看多了没甚道理的事情，难免会问，是不是书上的道理，是错的，或者说，是那些道理还没有说透，没有说全。” “那么问题来了，怎么办呢？我们该怎么看待这个许多嘴上讲道理、做事没道理的世界？办法是有的，一种是活得纯粹，我拳头很硬，剑术很强，道法很强，就用这些来打破一些东西。复杂问题给简单解决掉，只要我开心就好。天地有规矩约束我，我便一拳打破，世间有大道压我，我有一剑破万法。哪怕暂时做到如此酣畅淋漓，可总是如此想，坚定不移，一直朝这个方向走在道路上。这种人可以有，但是不能人人如此的。”一种是活得很聪明，怎么省心省力怎么来，规矩二字，就是用来钻漏洞的',
];